import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { PulsatingDot } from '@sales-portal/components/pulsating-dot';
import { toDaysAndHours, toHoursAndMinutes } from '@/utils/date';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

interface Props {
  millisecondsRemaining: number;
}

export const AgentAutoPublishCountdown: React.FC<Props> = ({
  millisecondsRemaining,
}) => {
  const [styles, theme] = useStyles();

  return (
    <View style={styles.container} testID="agent-auto-publish-countdown">
      <PulsatingDot color={theme.sk.color.icon.warning.secondary} />
      <Typography
        color={theme.sk.color.text.tertiary}
        numberOfLines={1}
        variant="paragraph-sm"
      >
        {millisecondsRemaining >= ONE_DAY_MS
          ? i18n.t(
              'pricing.agent.tasks.auto_publishes_in_days',
              toDaysAndHours(millisecondsRemaining),
            )
          : i18n.t(
              'pricing.agent.tasks.auto_publishes_in_hours',
              toHoursAndMinutes(millisecondsRemaining),
            )}
      </Typography>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceXsmall,
  },
}));
